import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import PaywallUpgradeDialog from '@/components/dialogs/PaywallUpgradeDialog.vue';
import { useVuetify } from '../helpers/vue2-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaywallButton',
  props: {
  unlocked: { type: Boolean, required: true },
  disabled: { type: Boolean, required: false, default: false },
  plans: { type: Array as PropType<('pro' | 'business' | 'ultimate')[]>, required: false, default: () => undefined },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;

const vuetify = useVuetify();





const upgradeDialog = ref(false);

const click = (event: any) => {
  if (props.unlocked) {
    emit('click', event);
    return;
  }
  upgradeDialog.value = true;
};

const badgeColor = computed(() => {
  if (!props.disabled) return 'red';
  if (vuetify.theme.dark) return 'grey darken-3';
  return 'grey lighten-1';
});


return { __sfc: true,vuetify, props, emit, upgradeDialog, click, badgeColor, PaywallUpgradeDialog }
}

})